import { Pipe, PipeTransform } from '@angular/core';

enum Type {
  ARRAY = 'ARRAY',
}

@Pipe({
  name: 'isType',
  standalone: true,
})
export class IsTypePipe implements PipeTransform {
  /**
   * Checks if the provided value matches the specified type.
   * @param value - The value to be checked.
   * @param type - The type to validate against, defined in the `Type` enum.
   * @returns `true` if the value matches the type; otherwise, `false`.
   */
  transform(value: unknown, type: Type): boolean {
    switch (type) {
      case Type.ARRAY:
        return Array.isArray(value);
      default:
        throw new Error(`Unsupported type: ${String(type)}`);
    }
  }
}
